import { PayPeriodData } from '../models/enhancement/pay-period-data'

export const formatPayPeriodDate = (dateString: string): string => {
  const date = new Date(dateString)
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }
  return date.toLocaleDateString(navigator.language, options)
}

export const formatPayPeriodDateRange = (payPeriod: PayPeriodData): string => 
  `${formatPayPeriodDate(payPeriod.periodStart)} - ${formatPayPeriodDate(payPeriod.periodEnd)}`

export const formatPayPeriodDisplay = (payPeriod: PayPeriodData): string =>
  `Pay Period ${payPeriod.period}: ${formatPayPeriodDate(payPeriod.periodEnd)}`

export const formatPayPeriodDisplayText = (period: number, periodEnd: string | Date): string => {
  const endDate = typeof periodEnd === 'string' ? new Date(periodEnd) : periodEnd
  
  const formattedDate = endDate.toLocaleDateString(navigator.language, {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
  
  return `Pay Period ${period} - ${formattedDate}`
}